export interface FolderNode<T> {
  name: string;
  path: string;
  children: FolderNode<T>[];
  items: T[];
}

/** 把带 folder 路径（如 "tech/rust"）的扁平列表组装成目录树 */
export function buildFolderTree<T>(items: T[], getFolder: (item: T) => string): FolderNode<T> {
  const root: FolderNode<T> = { name: '', path: '', children: [], items: [] };
  for (const item of items) {
    const parts = getFolder(item).split('/').filter(Boolean);
    let node = root;
    let path = '';
    for (const part of parts) {
      path = path ? `${path}/${part}` : part;
      let child = node.children.find((c) => c.name === part);
      if (!child) {
        child = { name: part, path, children: [], items: [] };
        node.children.push(child);
      }
      node = child;
    }
    node.items.push(item);
  }
  return root;
}

/** 递归统计节点下的条目总数 */
export function countItems<T>(node: FolderNode<T>): number {
  return node.items.length + node.children.reduce((sum, c) => sum + countItems(c), 0);
}
